<template>
  <v-container></v-container>
</template>

<script>
import { db } from "../firebase";
export default {
  name: "landing",

  async created() {
    this.email = this.$route.params.email.includes("@")
      ? this.$route.params.email
      : window.atob(this.$route.params.email);
    console.log(this.email);
    try {
      const userRef = await this.$firestore.users
        .where("email", "==", this.email)
        .get();
      userRef.docs.length == 0
        ? this.$router.push({
            path: `/login/mail/${this.$route.params.email}`
          })
        : this.$router.push({
            name: "microsoft"
          });
    } catch (e) {
      console.log(e);
    }
  },
  firestore() {
    return {
      users: db.collection("users")
    };
  }
};
</script>

<style lang="scss" scoped>
</style>

